import {Fragment} from 'react';
import {FaFacebookF, FaInstagram, FaLinkedin, FaTwitter, FaWhatsapp} from 'react-icons/fa';
import { MdOutlineEmail } from "react-icons/md";
import {NavLink} from 'react-router-dom';
import './Footer.css';
import {isUserLoggedIn} from '../../auth/utiles';
import {useAppSelector} from '../../hooks/hooks';
import {useTranslation} from 'react-i18next';
import { colors } from '../../constants/colors';

function Footer() {
  const {t} = useTranslation();
  const isCons = localStorage.getItem('isCons');
  const isLoggedIn = isUserLoggedIn();
  const consStatus = useAppSelector(state => state.user.consStatus);
  return (
    <Fragment>
      <div className="footer" id="footer"
      
      >
        <div className="container">
          <div className="row justify-content-between">
            <div className="FooterLogo">
              <img src="/champ-logo.png" alt="footerImg" />
            </div>

            <div className="col-md-3 mb-4">
              <h4 className="FooterTitle">{t('About Nurabi')}</h4>
              <p className="aboutNurabi">{t('footerAboutDesc')}</p>
            </div>

            <div className="col-md-2 mb-4">
              <h4 className="FooterTitle">{t('Site Map')}</h4>
              <div className="Sitemap">

              <p className="SiteLink">
                  <NavLink to="/user/initiatives/">{t('Competitions')}</NavLink>
                </p>
                <p className="SiteLink">
                  <NavLink to="/consultants/get-teachers">
                    {t('Mentors')}
                  </NavLink>
                </p>
                {(isCons !== 'true' || isCons == null || !isCons) &&
                  isLoggedIn &&
                  (consStatus == null || consStatus == 'rejected') && (
                    <p className="SiteLink">
                      <NavLink to="/user/consultation/request">
                        {t('join')}
                      </NavLink>
                    </p>
                  )}
                <p className="SiteLink">
                  <NavLink to="/courses">{t('Courses')}</NavLink>
                </p>
                <p className="SiteLink">
                  <NavLink to="/events-list">{t('Events')}</NavLink>
                </p>
                <p className="SiteLink">
                  <NavLink to="/user/trackings/list/">{t('Follow-up Systems')}</NavLink>
                </p>
                
                
                
              </div>
            </div>

            <div className="col-md-2 mb-4">
              <h4 className="FooterTitle">{t('Links')}</h4>
              <div className="Sitemap">
                <p className="SiteLink">
                  <NavLink to="https://apps.apple.com/eg/app/champions-%D8%AA%D8%B4%D8%A7%D9%85%D8%A8%D9%8A%D9%88%D9%86%D8%B2/id6456484767">
                    {t('App Store')}
                  </NavLink>
                </p>
                <p className="SiteLink">
                  <NavLink to="https://play.google.com/store/apps/details?id=com.championsacademy&pcampaignid=web_share">
                    {t('Play Store')}
                  </NavLink>
                </p>
                {!isLoggedIn && (
                  <div>
                    <p className="SiteLink mb-1">
                      <NavLink to="/login">{t('Login')}</NavLink>
                    </p>
                    <p className="SiteLink mb-1">
                      <NavLink to="/sign-up">{t('Register')}</NavLink>
                    </p>
                  </div>
                )}
                <p className="SiteLink">
                  <NavLink to="/contact-us">{t('Contact Us')}</NavLink>
                </p>
                <p className="SiteLink">
                  <NavLink to="/terms-and-conditions">
                    {t('Terms And Conditions')}
                  </NavLink>
                </p>
              </div>
            </div>

            <div className="col-md-2 mb-4">
              <h4 className="FooterTitle">{t('Download App')}</h4>
              <div className="Sitemap">
                <img
                  src="/champions-qr.jpeg"
                  className="mt-1"
                  style={{width: '100%', borderRadius: '15px', width: '100px'}}
                  alt="img"
                />
                {/* <p className='SiteLink'><NavLink to="/login">Login</NavLink></p>
                <p className='SiteLink'><NavLink to="/register">Register</NavLink></p> */}
              </div>
            </div>

            <div className="col-md-4 mb-md-4">
              <h4 className="FooterTitle">{t('Get In Touch With Us')}</h4>
              <div className="Sitemap">
                {/* <NavLink to="/">
                  <img
                    src="/contact/phone.png"
                    className="ContactImg"
                    alt="phone"
                  />
                </NavLink> */}
                <NavLink to="https://wa.me/+16472726035">
                  <FaWhatsapp size={35} color='#000' />
                </NavLink>
                <a href="mailto:info@championsacademy.ca" target="_blank" style={{margin:"0 10px"}}>
                  <MdOutlineEmail  size={35} color='#000'  />
                </a>
                {/* <NavLink to="/">
                  <img
                    src="/contact/web.png"
                    className="ContactImg"
                    alt="web"
                  />
                </NavLink> */}
                {/* <NavLink to="/">
                  <img
                    src="/contact/location.png"
                    className="ContactImg"
                    alt="location"
                  />
                </NavLink> */}
              </div>
            </div>

            <div className="col-md-4 SocialIcons">
              <FaFacebookF
                className="SocialIcon"
                size={35}
                onClick={() => {
                  window.open(
                    'https://www.facebook.com/ChPlatformEn?mibextid=qi2Omg&rdid=dVeX3kWgZhRJtmw0&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F5cLRVVTN3sy8oeoL%2F%3Fmibextid%3Dqi2Omg',
                    '_blank',
                  );
                }}
              />
              <FaInstagram
                className="SocialIcon"
                size={35}
                onClick={() => {
                  window.open(
                    'https://www.instagram.com/chplatformen?igsh=MXc1MzJmcHBsYXp4MQ==',
                    '_blank',
                  );
                }}
              />
              
              
            </div>
          </div>
        </div>
      </div>
      <div className="CopyRight"
      style={{
        background:colors.chamSecColor
      }}      
      >{t('Copyright © belongs to Nurabi')}</div>
    </Fragment>
  );
}

export default Footer;
